import { ElementType } from "../../dom-tools/ElementType";
import { TextFXLetter } from "./TextFXLetter";

export class TextFXModuleSettings
{
  module:TextFXModule;
}

export abstract class TextFXModule 
{
  abstract get type():ElementType<Element>

  abstract apply( letters:TextFXLetter[], settings:TextFXModuleSettings ):void;
  abstract getSettings( element:Element ):TextFXModuleSettings;
}